export default "__VITE_ASSET__Bo3n1oI5__"